export { default as BaseMenu } from "./BaseMenu";
export type { IBaseMenuConfig } from "./types";
